/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishpriceplaceholder4Inputs */

const en_menueditordishpriceplaceholder4 = /** @type {(inputs: Menueditordishpriceplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8.50`)
};

const de_menueditordishpriceplaceholder4 = /** @type {(inputs: Menueditordishpriceplaceholder4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8,50`)
};

/**
* | output |
* | --- |
* | "8.50" |
*
* @param {Menueditordishpriceplaceholder4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishpriceplaceholder4 = /** @type {((inputs?: Menueditordishpriceplaceholder4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishpriceplaceholder4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishpriceplaceholder4(inputs)
	return de_menueditordishpriceplaceholder4(inputs)
});
export { menueditordishpriceplaceholder4 as "menuEditorDishPricePlaceholder" }